import { OfferFilter, PolicyFilter } from '../../../domain/registry.domain';

export namespace RegistryAction {

    export class Clear {
        static readonly type = 'RegistryAction.Clear';
    }

    export class GetOffers {
        static readonly type = 'RegistryAction.GetOffers';

        constructor(public filter: OfferFilter) {
        }
    }

    export class GetOffersCSV {
        static readonly type = 'RegistryAction.GetOffersCSV';

        constructor(public filter: OfferFilter) {
        }
    }

    export class GetPolicies {
        static readonly type = 'RegistryAction.GetPolicies';

        constructor(public filter: PolicyFilter) {
        }
    }

    export class GetPoliciesCSV {
        static readonly type = 'RegistryAction.GetPoliciesCSV';

        constructor(public filter: PolicyFilter) {
        }
    }
}
